
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/forge/career.proxify.io/releases/20261023135732/sentry.client.config.js")
            }
          });